var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIbLogoSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ib-logo-small_svg__clip0_1175_2249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20.26V8.415L10.79 20.26H0z",
    fill: "url(#ib-logo-small_svg__paint0_linear_1175_2249)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.27 14.527a3.229 3.229 0 10-3.229-3.228 3.228 3.228 0 003.23 3.228zM0 8.414V20.26L10.79-4.08 0 8.414z",
    fill: "#D81222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ib-logo-small_svg__paint0_linear_1175_2249",
    x1: 10.776,
    y1: 14.338,
    x2: -0.017,
    y2: 14.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#960B1A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ib-logo-small_svg__clip0_1175_2249"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10z",
    fill: "#fff"
  })))));
}

export default SvgIbLogoSmall;